
import React, { useState } from 'react';
import './App.css';

import Sidebar from './Components/Sidebar';
import Login from './Components/Login';
import RegisterEmployee from './Components/RegisterEmp';

// --- Placeholder Components (Inko apne real components se replace kar lena) ---
const MyProfile = ({ user }) => (
  <div style={{ padding: '20px' }}>
    <h2>My Profile</h2>
    <div className="card">
      <p><strong>Name:</strong> {user.first_name} {user.last_name}</p>
      <p><strong>Email:</strong> {user.email}</p>
      <p><strong>Role:</strong> {user.role}</p>
      <p><strong>Designation:</strong> {user.designation}</p>
      <p><strong>Department:</strong> {user.department}</p>
    </div>
  </div>
);
const Attendance = () => <div style={{ padding: '20px' }}><h2>Attendance Page</h2></div>;
const LeaveApply = () => <div style={{ padding: '20px' }}><h2>Leave Application</h2></div>;
const Dashboard = () => <div style={{ padding: '20px' }}><h2>Admin Dashboard</h2></div>;
// ---------------------------------------------------------------------------

function App() {
  // 1. Auth State
  const [auth, setAuth] = useState(() => {
    const raw = sessionStorage.getItem('auth');
    return raw ? JSON.parse(raw) : null;
  });

  // 2. Navigation State (Default 'profile')
  const [activePage, setActivePage] = useState('profile');

  const isLoggedIn = !!auth;
  const isAdmin = auth?.role === 'Admin';

  const handleLoginSuccess = (user) => {
    // ✅ Change: Pura user object save kar rahe hain
    sessionStorage.setItem('auth', JSON.stringify(user));
    setAuth(user);
    setActivePage('profile'); // Login ke baad profile dikhaye
  };

  const handleLogout = () => {
    sessionStorage.removeItem('auth');
    setAuth(null);
    setActivePage('profile');
  };

  // --- Page Render Logic ---
  const renderContent = () => {
    switch (activePage) {
      case 'profile':
        return <MyProfile user={auth} />;

      case 'attendance':
        return <Attendance />;

      case 'leave':
        return <LeaveApply />;

 
      // --- Admin Only Pages ---
      case 'dashboard':
        return isAdmin ? <Dashboard /> : <p className="error">Access Denied</p>;

      case 'register':
        // Agar Admin nahi hai, to ye page nahi dikhega
        return isAdmin ? (
          <RegisterEmployee
            onBack={() => setActivePage('dashboard')}
            onSubmit={() => alert("Employee Added!")}
          />
        ) : (
          <div style={{ padding: '20px', color: 'red' }}>
            <h2>Access Denied</h2>
            <p>Only Admins can register new employees.</p>
          </div>
        );

      default:
        return <MyProfile user={auth} />;
    }
  };

  // Login nahi hai → Sirf Login screen
  if (!isLoggedIn) {
    return <Login onSuccess={handleLoginSuccess} />;
  }

  // Login ho gaya → Sidebar + Main Content
  return (
    <div className="app" style={{ display: 'flex', height: '100vh' }}>
      {/* Sidebar ko auth (user data) aur setActivePage function pass kiya */}
      <Sidebar
        auth={auth}
        activePage={activePage}
        setActivePage={setActivePage}
        onLogout={handleLogout}
      />

      <div className="main" style={{ flex: 1, overflowY: 'auto', background: '#f4f7f6' }}>
        {renderContent()}
      </div>
    </div>
  );
}

export default App;